import { Controller } from "@hotwired/stimulus"

// 오른쪽 장바구니 패널의 조작.
//
// 수량·비고를 고치면 바로 저장한다(별도의 저장 버튼을 누르지 않아도 되게).
// 구 웹수발주는 "주문일괄저장" 하나로 처리했지만, 값이 반영됐는지 바로 보이는 편이
// 오주문을 줄인다. 일괄 저장 버튼도 그대로 남겨 뒀다.
export default class extends Controller<HTMLElement> {
  static targets = ["row"]

  declare readonly rowTargets: HTMLInputElement[]

  // 수량/비고를 고치면 그 폼을 그대로 제출한다 (Turbo 가 장바구니만 다시 그린다).
  save(event: Event): void {
    const form = (event.target as HTMLElement).closest("form")
    form?.requestSubmit()
  }

  // 머리글의 전체 선택 체크박스
  toggleAll(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked
    for (const row of this.rowTargets) row.checked = checked
  }
}
